import React from 'react';
import { Box } from '@mui/material';
import { Uniform } from '../../../../components/uniform/uniform';
import { UniformStepContainer } from '../../../../components/uniform/uniform-step-container';
import { UniformStep } from '../../../../components/uniform/uniform-step';
import { Accordion, AccordionSummary, AccordionDetails } from '../../../../components/accordion';
import { Row } from '../../../../components/row';
import { Cell } from '../../../../components/cell';
import { TextField } from '../../../../components/text-field';
import { CompanyLookup } from '../../../../components/lookups';
import { ICompanyLookup } from '../../../../components/lookups/company-lookup/interfaces';
import { RegistrationCounterTitlezone } from './registration-counter-titlezone';
import { RegistrationCounterLaunchbox } from './registration-counter-launchbox';
import { ReadonlyInput } from '../../../../components/readonly-input';

export interface RegistrationCounterState {
  name?: string;
  companyId?: string;
  externalReference?: string;
  isActivated: boolean;
  hasActivationKey: boolean;
}

export interface RegistrationCounterErrors {
  name?: string;
  companyId?: string;
  externalReference?: string;
}

interface IRegistrationCounterComponentProps {
  isEditMode: boolean;
  isReadOnly: boolean;
  isSaving: boolean;
  isDeleting: boolean;
  isGeneratingActivationKey: boolean;
  registrationCounter: RegistrationCounterState;
  errors: RegistrationCounterErrors;
  onSaveClick: () => void;
  onValidate: () => boolean;
  onDeleteClick: () => void;
  onGenerateActivationKeyClick: () => void;
  onNameChange: (name: string) => void;
  onExternalReferenceChange: (externalReference: string) => void;
  onCompanyChange: (company?: ICompanyLookup) => void;
}

export function RegistrationCounterComponent(props: IRegistrationCounterComponentProps) {
  const {
    isEditMode,
    isReadOnly,
    isSaving,
    isDeleting,
    isGeneratingActivationKey,
    registrationCounter,
    errors,
    onSaveClick,
    onValidate,
    onDeleteClick,
    onGenerateActivationKeyClick,
    onNameChange,
    onExternalReferenceChange,
    onCompanyChange,
  } = props;
  const { name, companyId, externalReference } = registrationCounter;

  return (
    <Uniform
      titleZone={<RegistrationCounterTitlezone isEditMode={isEditMode} />}
      launchbox={
        <RegistrationCounterLaunchbox
          isEditMode={isEditMode}
          isReadOnly={isReadOnly}
          isSaving={isSaving}
          isDeleting={isDeleting}
          isGeneratingActivationKey={isGeneratingActivationKey}
          onSave={onSaveClick}
          onValidate={onValidate}
          onDelete={onDeleteClick}
          onGenerateActivationKey={onGenerateActivationKeyClick}
        />
      }
      isEditMode={isEditMode}
      showButtons={!isEditMode}
      onOk={onSaveClick}
      onCancel={() => window.close()}
      okButtonIsLoading={isSaving}
      showSpinnerOnNextAndComplete={isSaving}
    >
      <UniformStep stepName="Generelt" validate={onValidate}>
        <UniformStepContainer>
          <Accordion defaultExpanded>
            <AccordionSummary>Infostander</AccordionSummary>
            <AccordionDetails>
              <Box mt={1}>
                <Row>
                  <Cell size="full">
                    {!isReadOnly ? (
                      <TextField
                        variant="outlined"
                        value={name}
                        label="Navn"
                        onChange={event => onNameChange(event.target.value)}
                        required
                        error={!!errors.name}
                        errorText={errors.name}
                      />
                    ) : (
                      <ReadonlyInput label="Navn" value={name} />
                    )}
                  </Cell>
                </Row>
                <Row>
                  <Cell size="full">
                    {!isReadOnly ? (
                      <TextField
                        variant="outlined"
                        value={externalReference}
                        label="Ekstern reference"
                        onChange={event => onExternalReferenceChange(event.target.value)}
                        error={!!errors.externalReference}
                        errorText={errors.externalReference}
                      />
                    ) : (
                      <ReadonlyInput label="Ekstern reference" value={externalReference} />
                    )}
                  </Cell>
                </Row>
                <Row>
                  <Cell size="full">
                    <CompanyLookup label="Virksomhed" value={companyId} onChange={onCompanyChange} required error={!!errors.companyId} errorText={errors.companyId} readOnly={isReadOnly} />
                  </Cell>
                </Row>
              </Box>
            </AccordionDetails>
          </Accordion>
        </UniformStepContainer>
      </UniformStep>
    </Uniform>
  );
}
